
export const playerIdColors = {
  [`id-${3}`]: { color: '#00A6D6' },   //votorantim- PADRÃO
  [`id-${155}`]: { color: '#C00000' }, //inter - PADRÃO
  [`id-${145}`]: { color: '#1F62AE' }, //bre - PADRÃO
  [`id-${158}`]: { color: '#348592' }, //lafe - PADRÃO
  [`id-${151}`]: { color: '#A02B93' }, //csn - PADRÃO
  [`id-${160}`]: { color: '#F58220' }, //mizu - PADRÃO
  [`id-${150}`]: { color: '#00395D' }, //crh - PADRÃO
  [`id-${156}`]: { color: '#90BE44' }, //itambe - PADRÃO
  [`id-${165}`]: { color: '#C5E0B4' }, //supremo - PADRÃO
  [`id-${23}`]: { color: '#BF9000' }, //ciplan - PADRÃO
  [`id-${159}`]: { color: '#EF4056' }, //liz - PADRÃO
  [`id-${166}`]: { color: '#000000' }, //tupi, - PADRÃO
  [`id-${161}`]: { color: '#613407' }, //nassau - PADRÃO
  [`id-${142}`]: { color: '#548235' }, //APO - PADRÃO
  [`id-${152}`]: { color: '#B4C7E7' }, //ELIZABETH - PADRÃO
};

export const outrosColors = [
  { color: '#939598' }, //OUTROS
  { color: '#8B4513' }, // Marrom
  { color: '#FF6347' }, // Tomate
  { color: '#4682B4' }, // Aço Azul
  { color: '#8A2BE2' }, // Azul Violeta
  { color: '#32CD32' }, // Verde Limão
  { color: '#FFD700' }, // Ouro
  { color: '#FF4500' }, // Vermelho Laranja
  { color: '#800000' }, // Marrom Escuro
  { color: '#FFFF00' }, // Amarelo
  { color: '#800080' }, // Roxo
  { color: '#00FFFF' }, // Ciano
  { color: '#8FBC8F' }, // Cinza Verdoso
  { color: '#FF69B4' }, // Rosa Choque
  { color: '#228B22' }, // Verde Floresta
  { color: '#DAA520' }, // Dourado Antigo
  { color: '#4682B4' }, // Azul Aço
  { color: '#191970' }, // Azul Meia-Noite
  { color: '#696969' }, // Cinza Dim
  { color: '#D2B48C' }, // Marrom Claro
  { color: '#FF7F50' }, // Coral Claro
  { color: '#8A2BE2' }, // Azul Violeta
  { color: '#00CED1' }, // Azul Turquesa
  { color: '#20B2AA' }, // Verde Mar
  { color: '#800000' }, // Marrom Escuro
  { color: '#B0C4DE' }, // Azul Claro
  { color: '#E9967A' }, // Salmão Claro
  { color: '#ADFF2F' }, // Verde Amarelo
  { color: '#FF69B4' }, // Rosa Choque
  { color: '#FAEBD7' }, // Branco Antigo
  { color: '#8FBC8F' }, // Cinza Verdoso
];

export const playerNameColors = {
  VOTORANTIM: playerIdColors["id-3"].color,
  INTERCEMENT: playerIdColors["id-155"].color,
  BRENNAND: playerIdColors["id-145"].color,
  BRE: playerIdColors["id-145"].color,
  "LAFARGE HOLCIM": playerIdColors["id-158"].color,
  LAFARGE: playerIdColors["id-158"].color,
  CSN: playerIdColors["id-151"].color,
  MIZU: playerIdColors["id-160"].color,
  CRH: playerIdColors["id-150"].color,
  ITAMBE: playerIdColors["id-156"].color,
  SUPREMO: playerIdColors["id-165"].color,
  CIPLAN: playerIdColors["id-23"].color,
  LIZ: playerIdColors["id-159"].color,
  TUPI: playerIdColors["id-166"].color,
  NASSAU: playerIdColors["id-161"].color,
  APODI: playerIdColors["id-142"].color,
  APO: playerIdColors["id-142"].color,
  ELIZABETH: playerIdColors["id-152"].color,
  OUTROS: outrosColors[0].color,
};

export const playerFallbackColors = outrosColors.slice(1).map((c) => c.color);

const normalizarPlayer = (nome) =>
  String(nome ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toUpperCase();

export const getPlayerColor = (nome, indice = 0, coresExtras = {}) => {
  const chave = normalizarPlayer(nome);
  return (
    playerNameColors[chave] ??
    coresExtras[chave] ??
    playerFallbackColors[indice % playerFallbackColors.length]
  );
};
